
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?-autoprefixer&sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-b0137c32\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./HeaderSpinneybeck.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HeaderSpinneybeck.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b0137c32\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HeaderSpinneybeck.vue"),
  /* scopeId */
  "data-v-b0137c32",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/client/pages/wrappers/HeaderSpinneybeck.vue
// module id = 560
// module chunks = 1